import React, {FC} from 'react';

import {NON_PRESCRIPTION} from 'constants/product';

import {
    useDescription,
    usePrismContent,
    useUsage,
} from 'desktop/components/cartItemHelper/cartItemHelper';

import {CartItemGlassesTypeV2Type} from '../../types';
import {BaseInfoRow} from '../baseInfoRowV2/baseInfoRow';
import {BaseQtySwitcherConnected} from '../baseQtySwitcher/baseQtySwitcher';
import {CartItemEyeglassesPrescription} from '../cartItemEyeglassesPrescription/cartItemEyeglassesPrescription';

type PropsType = {
    item: CartItemGlassesTypeV2Type;
};

/**
 * Cart collapsible content
 * @constructor
 */
export const CartCollapsibleContent: FC<PropsType> = ({item}) => {
    const usage = useUsage(item);
    const prismContent = usePrismContent(item);
    const description = useDescription(item, item.type);

    return (
        <>
            <BaseQtySwitcherConnected id={item.id} />
            <BaseInfoRow
                title={
                    <>
                        <span data-test-name="color">{item.frame.color}</span>
                        {item.frame.frameSize && (
                            <span data-test-name="frameSize">, {item.frame.frameSize}</span>
                        )}
                    </>
                }
                dataTestName="frameInfo"
                label="Frame:"
                price={item.frame.price}
                specialPrice={item.frame.specialPrice}
            />
            {item.prescription && usage && (
                <CartItemEyeglassesPrescription
                    description={description}
                    prescription={item.prescription}
                    price={usage.price}
                    prismContent={prismContent}
                    specialPrice={usage.finalPrice}
                    usageName={usage.title}
                />
            )}
            {!item.prescription && usage && (
                <BaseInfoRow
                    dataTestName="useGlassesFor"
                    dataTestValue={usage.title}
                    description={description}
                    label="Lens:"
                    postfix={prismContent}
                    price={usage.price}
                    specialPrice={usage.finalPrice}
                    title={usage.sku === NON_PRESCRIPTION ? usage.usageName : usage.title}
                />
            )}
        </>
    );
};
